import * as z from "zod/v4";

export const createEmailTemplateFromDefault = {
  name: "createEmailTemplateFromDefault" as const,
  input: z.object({ defaultTemplateId: z.string() }),
  output: z.object({ id: z.string() }),
};
